import { createFileRoute } from "@tanstack/react-router";
import { CardPage } from "../../../components/board/card-dialog";

/** A board card opened as a full page (from the card's "Open as page", or a notification). */
export const Route = createFileRoute("/_app/c/$boardId/$cardId")({
	component: CardScreen,
});

function CardScreen() {
	const { boardId, cardId } = Route.useParams();
	return <CardPage key={`${boardId}:${cardId}`} boardId={boardId} cardId={cardId} />;
}
